import React from 'react';
import { Outlet } from 'react-router-dom';
import { Logo } from '../components-core/landing/Logo';
import { Box } from '@mui/system';
// material
import { styled } from '@mui/material/styles';

import Header from '../layouts/client/dashboard/header/Header';
import Navbar from '../layouts/client/dashboard/navbar/Navbar';


// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  overflow: 'hidden',
  margin: '0 5px'
});

const HeaderStyle = styled('div')(({ theme }) => ({
  padding: '20px 0px',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default () => {
  const [open, setOpen] = React.useState(false);

  return (
    <RootStyle>
      <HeaderStyle>
        <Header />
      </HeaderStyle>
      <MainStyle>
        <Navbar />
        <Box height={20} />
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
};
